import React from "react"
import { Table as AntTable } from "antd"
import { ExtraButtons } from "src/components/extra-buttons"
import { Header } from "src/components/layout/header"
import { TableSearch } from "src/components/table-search"
import { VisibilityProvider } from "src/components/visibility-provider"
import { useUpdateHeaderTitle, usePermission } from "src/hooks"
import { EditDrawer } from "src/pages-lib/permissions/edit-drawer"
import { useGetData, useManageItems } from "src/pages-lib/permissions/model"
import { getColumns } from "src/pages-lib/permissions/table-columns"
import styled from "styled-components"

export default function Permissions() {
  const { hasPermission } = usePermission()
  const [createDrawerState, setCreateDrawerState] = React.useState(false)
  const [editDrawerState, setEditDrawerState] = React.useState(false)

  const {
    dataItems,
    dataItemsColumns,
    pagination,
    isLoading,
    handleTableChange,
    handleSearchTable,
    refetch: getItems,
  } = useGetData()

  const { editData, resetData, onSaveEdit, onCreate, onDelete, onEditItem } =
    useManageItems(dataItems, getItems, onSuccessEdit, onSuccessCreate)

  const headerTitle = useUpdateHeaderTitle({
    items: dataItems,
    defaultTitle: "0 Разрешений",
    arrType: ["Разрешений", "Разрешение", "Разрешений"],
  })

  const columns = getColumns(hasPermission("permissions.edit") ? onEditItem : null, hasPermission("permissions.delete") ? onDelete : null)

  function onSuccessEdit() {
    setEditDrawerState(!editDrawerState)
  }

  function onSuccessCreate() {
    setCreateDrawerState(!createDrawerState)
  }

  return (
    <>
      <Header
        title={headerTitle}
        extra={
          <ExtraButtons
            onCreate={hasPermission("permissions.create") ? () => setCreateDrawerState(true) : undefined}
            titles={{ onCreate: "Добавить разрешение" }}
          />
        }
      />
      <TableSearch handleSearch={handleSearchTable} placeholder={"Поиск по ID, названию или слагу"} />
      <StyledTable
        dataSource={dataItemsColumns}
        columns={columns}
        loading={isLoading}
        onChange={handleTableChange}
        pagination={pagination}
      />

      {hasPermission("permissions.create") && (
        <VisibilityProvider visible={createDrawerState}>
          <EditDrawer
            onSave={onCreate}
            onClose={() => setCreateDrawerState(false)}
            title={"Создание разрешения"}
            visible={createDrawerState}
          />
        </VisibilityProvider>
      )}

      {hasPermission("permissions.edit") && (
        <VisibilityProvider visible={editDrawerState}>
          <EditDrawer
            onSave={onSaveEdit}
            onClose={() => {
              setEditDrawerState(false)
              resetData()
            }}
            initialValues={editData}
            title={"Редактирование разрешения"}
            visible={editDrawerState}
          />
        </VisibilityProvider>
      )}
    </>
  )
}

const StyledTable = styled(AntTable)`
  .row-can-view {
    cursor: pointer;
  }
`
